export enum ProcessParticipationApprovalRequirementType {
     None = 0,
     ByAppraisee = 1,
     ByPerformanceManager = 2,
     ByDepartmentAdministrator = 4
}